import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageCircle, FiZap, FiTrendingUp } = FiIcons;

const HeroSection = () => {
  const handleCTAClick = () => {
    window.open('https://abdul.cc/awaaipay', '_blank');
  };

  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden px-4 sm:px-6 lg:px-8">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <motion.div 
          className="absolute top-20 left-10 text-green-400 opacity-20"
          animate={{ 
            rotate: 360,
            scale: [1, 1.2, 1]
          }}
          transition={{ 
            duration: 8, 
            repeat: Infinity,
            ease: "linear"
          }}
        >
          <SafeIcon icon={FiMessageCircle} className="text-6xl sm:text-8xl" />
        </motion.div>
        
        <motion.div 
          className="absolute top-32 right-16 text-blue-400 opacity-20"
          animate={{ 
            rotate: -360,
            y: [-20, 20, -20]
          }}
          transition={{ 
            duration: 6, 
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <SafeIcon icon={FiZap} className="text-5xl sm:text-7xl" />
        </motion.div>

        <motion.div 
          className="absolute bottom-20 left-20 text-green-300 opacity-20"
          animate={{ 
            scale: [1, 1.3, 1],
            rotate: [0, 180, 360]
          }}
          transition={{ 
            duration: 10, 
            repeat: Infinity
          }}
        >
          <SafeIcon icon={FiTrendingUp} className="text-4xl sm:text-6xl" />
        </motion.div>
      </div>

      <div className="text-center z-10 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            <span className="text-4xl sm:text-5xl">🚀</span> AI WhatsApp Automation<br />
            for <span className="text-green-400">Leads & Sales</span><br />
            with <span className="text-blue-400">AWA AI</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <p className="text-lg sm:text-xl md:text-2xl text-yellow-300 mb-6 font-semibold">
            <span className="text-2xl sm:text-3xl">🔥</span> Only for First 15 Tamil Business Owners | 
            <span className="text-2xl sm:text-3xl"> ⏰</span> Offer Ends 30th Sept 2025 10PM IST Sharp!
          </p>
          
          {/* New Pricing Highlight */}
          <div className="bg-gradient-to-r from-green-500 to-yellow-500 text-black rounded-2xl p-4 sm:p-6 mb-6 mx-auto max-w-2xl">
            <h2 className="text-2xl sm:text-3xl font-bold mb-2">
              🎯 Pay for 1 Month & Get 12 Months FREE!
            </h2>
            <p className="text-lg sm:text-xl font-semibold">
              Just ₹4,997/month → Get Full Year Access!
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <button
            onClick={handleCTAClick}
            className="bg-green-500 hover:bg-green-400 text-black text-xl sm:text-2xl font-bold py-4 sm:py-6 px-8 sm:px-12 rounded-full shadow-2xl transform hover:scale-105 transition-all duration-300 mb-4 animate-pulse"
          >
            Claim My Spot Now 🚀
          </button>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="text-red-400 text-lg sm:text-xl font-semibold"
        >
          Limited Seats. Lock Your Deal Today.
        </motion.p>
      </div>
    </section>
  );
};

export default HeroSection;